import { ChangelogModel, LocalizedText } from './Gen/BaseModels';
import * as siteConfig from '../site-config/config';

ChangelogModel.prototype._ModelExtender = function (parent, p, pp, mappingOptions) {
    var me = this;

    mappingOptions.partialConfig = {
        create: function (options) {
            return new siteConfig.ChangelogDescriptor(options.data);
        }
    };

    me.formattedPublished = ko.computed(() => {
        if (me.isPublished()) {
            return '<span class="badge badge-success">Published</span>';
        } else {
            return '<i>Not published</i>';
        }
    });

    me.title = function (lng) {
        return ko.computed({
            read: () => {
                var v = parent.titlesObject().filter(i => i.lng() === lng)[0];

                if (!v) {
                    return '';
                }

                return v.content();
            },
            write: val => {
                var cnt = parent.titlesObject().filter(i => i.lng() === lng)[0];

                if (!cnt) {
                    cnt = new LocalizedText();
                    cnt.lng(lng);
                    parent.titlesObject.push(cnt);
                }

                cnt.content(val);
            }
        });
    };

    me.content = function (lng) {
        return ko.computed({
            read: () => {
                //console.log('READDD', parent.contentsObject().filter(i => i.lng() === lng)[0].content());
                var v = parent.contentsObject().filter(i => i.lng() === lng)[0];

                if (!v) return '';

                return v.content();
            },
            write: val => {
                var cnt = parent.contentsObject().filter(i => i.lng() === lng)[0];

                if (!cnt) {
                    cnt = new LocalizedText();
                    cnt.lng(lng);
                    parent.contentsObject.push(cnt);
                }
                cnt.content(val);
            }
        });
    };
};

export default function () {
}